import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1824acd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quick-calming content-container" }
const _hoisted_2 = { class: "quick-calming__list" }

import { computed, reactive } from 'vue';
import { useRouter } from 'vue-router';

import {
  formatStringForUrlQuery,
  getFirebaseStorageFileUrl,
} from '@/services/methods';
import { TherapyBarItem, UiTherapyTabItemI } from '@/types/ui';
import api from '@/api';
import { onIonViewWillEnter, IonPage, IonContent } from '@ionic/vue';
import { useInternalization } from '@/composables/useInternalization';

import TherapyVideoItem from '@/components/TherapyVideoItem.vue';
import TheHeader from '@/components/TheHeader.vue';
import TherapyListTabs from '@/components/TherapyListTabs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickCalmListPage',
  setup(__props) {

const router = useRouter();
const { t } = useInternalization();

const listTabs = computed<UiTherapyTabItemI[]>(() => [
  { value: 'all', title: t('quickCalmingListTabs.all') },
  { value: 'stress', title: t('quickCalmingListTabs.stress') },
  { value: 'panic', title: t('quickCalmingListTabs.panic') },
  { value: 'anxiety', title: t('quickCalmingListTabs.anxiety') },
  { value: 'fear', title: t('quickCalmingListTabs.fear') },
  { value: 'anger', title: t('quickCalmingListTabs.anger') },
  { value: 'pain', title: t('quickCalmingListTabs.pain') },
  { value: 'conflict', title: t('quickCalmingListTabs.conflict') },
  { value: 'tension', title: t('quickCalmingListTabs.tension') },
  { value: 'fallAsleep', title: t('quickCalmingListTabs.fallAsleep') },
  { value: 'panickAtacks', title: t('quickCalmingListTabs.panickAtacks') },
  {
    value: 'negativeThought',
    title: t('quickCalmingListTabs.negativeThought'),
  },
]);

const state = reactive({
  quickCalmItems: [] as TherapyBarItem[],
  selectedListTabValue: listTabs.value[0].value as UiTherapyTabItemI['value'],
});

const quickCalmBarItemsFiltered = computed(() => {
  if (state.selectedListTabValue === 'all') {
    return state.quickCalmItems;
  }
  return state.quickCalmItems.filter(
    (item) =>
      item.type?.toLowerCase() === state.selectedListTabValue.toLowerCase()
  );
});

onIonViewWillEnter(async () => {
  await getQuickCalmVideos();
});

async function getQuickCalmVideos() {
  console.log('GETTING QUICK CALM VIDEOS');
  const res = await api.courses.getAllQuickCalmVideos();
  console.log('state.quickCalmVideos', res);

  state.quickCalmItems = res.map((v) => ({
    id: v.id,
    title: v.title,
    text: v.text,
    img: getFirebaseStorageFileUrl(v.imgPath),
    type: v.type,
    translations: v.translations,
  }));
}

function handleQuickCalmClick(item: TherapyBarItem) {
  router.push({
    name: 'TherapyQuickCalmVideo',
    params: { id: item.id },
    query: { title: formatStringForUrlQuery(item.title) },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(TheHeader, {
            title: _unref(t)('quickCalmingTools')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TherapyListTabs, {
              class: "quick-calming__tabs",
              tabs: listTabs.value,
              "selected-tab-value": state.selectedListTabValue,
              "onUpdate:selectedTabValue": _cache[0] || (_cache[0] = ($event: any) => (state.selectedListTabValue = $event))
            }, null, 8, ["tabs", "selected-tab-value"]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickCalmBarItemsFiltered.value, (item) => {
                return (_openBlock(), _createBlock(TherapyVideoItem, {
                  class: "quick-calming__list-item",
                  key: item.id,
                  item: item,
                  square: "",
                  "title-on-img": "",
                  "hide-tag": "",
                  "onItem:click": handleQuickCalmClick
                }, null, 8, ["item"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})